export const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

// function that returns a promise that is delayed at least by the given amount of milliseconds
export async function withArtificialDelay<T>(promise: Promise<T>, duration: number = 1000): Promise<T> {
  const [result] = await Promise.all([promise, delay(duration)]);

  return result;
}
